import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './portfolioSummaryChartPreview.png';
import gridPreview from './portfolioSummaryGridPreview.png';
import treemapPreview from './portfolioSummaryTreemapPreview.png';

export const portfolioSummaryDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Portfolio Summary, available in a chart, treemap and table
                view, is used to assist in pre-trade analysis and ongoing
                monitoring by analyzing the characteristics of a basket. It
                displays the notional value in the base currency by a chosen
                grouping.
            </div>
        </>
    ),
    minPreviewHeight: 250,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'portfolio-summary-chart-preview',
        },
        {
            title: 'Table',
            src: gridPreview,
            altText: 'portfolio-summary-table-preview',
        },
        {
            title: 'Treemap',
            src: treemapPreview,
            altText: 'portfolio-summary-treemap-preview',
        },
    ],
};
